import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';

export default function addReviewNavigation() {
  extend(SessionDropdown.prototype, 'items', function (items) {
    if (!app.forum.attribute('canViewFlags')) return;

    const pendingCount = Math.max(0, Number(app.forum.attribute('flagCount')) || 0);

    items.add(
      'yingtaoReviewTasks',
      <LinkButton icon="fas fa-shield-alt" href={app.route('yingtaoReviewTasks')}>
        {app.translator.trans('yingtao-forum-homepage.forum.review.nav')}
        {pendingCount > 0 ? <span className="Button-badge">{pendingCount > 99 ? '99+' : pendingCount}</span> : null}
      </LinkButton>,
      10
    );
  });
}
